import React, { useEffect, useState } from "react";
import { Button, Col, DatePicker, Input, Popover, Row, Select, Slider } from "antd";
import { DollarOutlined, SwapOutlined } from "@ant-design/icons";
import { get } from "@services/api.service";
import { useHasAccess } from "@hooks/useHasAccess";
import { useQuery } from "@hooks/useQuery";
import { useNotification } from "~/Hooks/useNotification";
import { numberToString } from "~/Utils/CommonUtils";
import { useAuth } from "~/Hooks/useAuth";
import { spaBudget, spaFilterBudget, spaFilterPaper, spaPaper } from "~/Utils/StringConstants";
import { useSearchParams } from "react-router-dom";
import moment from 'moment';

interface Props {
  onChange: (amounts: { min: string; max: string }) => void;
}

export const FilterDropDown = ({
  viewStatus,
  isDashboard = false,
  viewSubsidiary,
  viewBudget,
  viewPaper,
  setStatus,
  viewDivisions,
  setDivision,
  setBudget,
  setPaper,
  setAmountData,
  setSubsidiary,
  setpage,
  clearFilter,
  clearSearchData,
  setDate,
  viewDate,
  onChange,
  setAmountRange,
  isMobile,
}: {
  viewStatus?: boolean;
  viewDate?: boolean;
  viewSubsidiary?: boolean;
  setSubsidiary?: any;
  viewDivisions?: boolean;
  setStatus?: any;
  clearFilter?: any;
  setpage?: any;
  clearSearchData?: any;
  setAmountData?: any;
  setDivision?: any;
  setBudget?: any;
  setPaper?: any;
  setDate?: any;
  onChange?: any;
  viewBudget: boolean;
  viewPaper: boolean;
  setAmountRange?: any;
  isDashboard?: boolean;
  isMobile?:boolean;
}) => {
  const [subsidiaryData, setSubsidiaryData] = useState([]);
  const [divisionData, setDivisionData] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState("");
  const [selectedPaper, setSelectedPaper] = useState("");
  // const [fromDate, setFromDate] = useState(null);
  // const [toDate, setToDate] = useState(null);
  const [sliderValue, setSliderValue] = useState<any>([0, 10000000]);
  const [inputValues, setInputValues] = useState({
    min: "0",
    max: "10000000",
  });
  const [open, setOpen] = useState(false);
  const [hideAmountLabel, setHideAmountLabel] = useState(false);
  const [showLabel, setShowLabel] = useState(true);
  const { openToast } = useNotification();
  const { RangePicker } = DatePicker;
  const pathname = window.location.pathname;
  const dashboardPath: any = "/dashboard";
  const isDashboardPath = pathname.includes(dashboardPath);
  const query = useQuery();
  const authority = query.get("authority");


  const [searchParams, setSearchParams] = useSearchParams();
  const paramsObj = Object.fromEntries(searchParams.entries());
  const startDate =searchParams.get("startDate")
  const endDate =searchParams.get("endDate")
  const subsidiary =searchParams.get("subsidiary")
  const division =searchParams.get("division")
  const budget =searchParams.get("budget")
  const paper =searchParams.get("paper")
  
  const handleSliderChange = (value: any) => {
    setSliderValue(value);
    setInputValues({
      min: value[0].toString(),
      max: value[1].toString(),
    });
    setAmountRange(`${value[0]}-${value[1]}`);
  };


  const getSubsidiaryRecords = () => {
    const subsidiaryUrl = `v1/subsidiary/all-subsidiary`;
    get(subsidiaryUrl)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          const responseData = res.response.data;
          if (responseData) {
            setSubsidiaryData(responseData);
          } else {
            console.error("No records found in the response");
            setSubsidiaryData([]);
          }
        } else {
          console.error("Unexpected response structure:", res);
        }
      })
      .catch((err: any) => {
        console.error("API Error:", err);
        openToast({
          content: "Getting Subsidiary/Division failed",
          type: "error",
        });
      });
  };

  const handleDateRangeChange = (dates: any, dateStrings: any) => {  
    if (!dates) {
      const newParams = new URLSearchParams(paramsObj);
      newParams.delete("startDate");
      newParams.delete("endDate");
      setSearchParams(newParams);
      return;
    }

    setSearchParams({...paramsObj, 
      ...(dates?.[0] && dates?.[1]? {
      "startDate": dates?.[0]?.format('YYYY-MM-DD'),
      "endDate": dates?.[1]?.format('YYYY-MM-DD') }:{}),
    });
  };

  const hide = (newOpen: boolean) => {
    setOpen(newOpen);
    setHideAmountLabel(false);
  };

  const onHandleRange = () => {
    setSearchParams({...paramsObj, 
      "startAmount": sliderValue?.[0] ?? "0",
      "endAmount": sliderValue?.[1] ?? "10000000"
    });
    // setAmountData(sliderValue);
    // setAmountRange(`${sliderValue[0]}-${sliderValue[1]}`);
    setOpen(false);
    setHideAmountLabel(true);
    setShowLabel(false);
  };
  const startAmount =searchParams.get("startAmount")
  const endAmount =searchParams.get("endAmount")

  useEffect(() => {
    if(startAmount && endAmount){
      setSliderValue([startAmount,endAmount])
      setHideAmountLabel(true);
      setShowLabel(false);
    }
  },[])

  const handleReset = () => {
    setHideAmountLabel(false);
    setOpen(false);
    setSliderValue([0, 10000000]);
    setInputValues({ min: "0", max: "10000000" });
    const newParams = new URLSearchParams(paramsObj);
    newParams.delete("startAmount");
    newParams.delete("endAmount");
    setSearchParams(newParams);
    // setAmountData([0, 10000000]);
    setAmountRange("0-10000000");
  };

  const validateSliderValue = (value: number, min: number, max: number) => {
    if (isNaN(value)) return min;
    return Math.min(Math.max(value, min), max);
  };

  const handleMinInputChange = (value: string) => {
    setInputValues((prev) => ({ ...prev, min: value }));

    // Only update slider if value is valid
    const numValue = Number(value);
    if (!isNaN(numValue)) {
      const minValue = validateSliderValue(numValue, 0, sliderValue[1]);
      setSliderValue([minValue, sliderValue[1]]);
    }
  };

  const handleMaxInputChange = (value: string) => {
    setInputValues((prev) => ({ ...prev, max: value }));

    // Only update slider if value is valid
    const numValue = Number(value);
    if (!isNaN(numValue) && numValue >= sliderValue[0]) {
      const maxValue = validateSliderValue(numValue, sliderValue[0], 10000000);
      setSliderValue([sliderValue[0], maxValue]);
    }
  };

  const handleInputBlur = (type: "min" | "max") => {
    const value = type === "min" ? inputValues.min : inputValues.max;
    const numValue = Number(value);

    if (type === "min") {
      const validatedMin = validateSliderValue(isNaN(numValue) ? 0 : numValue, 0, sliderValue[1]);
      setSliderValue([validatedMin, sliderValue[1]]);
      setInputValues((prev) => ({ ...prev, min: validatedMin.toString() }));
    } else {
      const validatedMax = validateSliderValue(isNaN(numValue) ? sliderValue[0] : numValue, sliderValue[0], 10000000);
      setSliderValue([sliderValue[0], validatedMax]);
      setInputValues((prev) => ({ ...prev, max: validatedMax.toString() }));
    }
  };

  const content = (
    <>
      <div style={{ marginTop: 48 }}>
        <Slider
          style={isMobile?{width:"260px"}:{ width: "350px" }}
          range={{ draggableTrack: true }}
          value={sliderValue}
          onChange={handleSliderChange}
          min={0}
          tooltip={{
            open,
            formatter: (e: any) => {
              return numberToString(e);
            },
          }}
          max={10000000}
        />
        <div style={{ cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              Min.
              <Input
                value={inputValues.min}
                onChange={(e) => handleMinInputChange(e.target.value)}
                onBlur={() => handleInputBlur("min")}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              Max.
              <Input
                value={inputValues.max}
                onChange={(e) => handleMaxInputChange(e.target.value)}
                onBlur={() => handleInputBlur("max")}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ border: " 1px solid #8080800f", marginTop: "12px" }}></div>
      <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
        <Button
          type="ghost"
          onClick={handleReset}
          style={{ flexGrow: 1 }}
        >
          Reset
        </Button>
        <Button
          onClick={onHandleRange}
          type="primary"
          style={{ flexGrow: 1 }}
        >
          Set Range
        </Button>
      </div>
    </>
  );

  const handleOpenChange = (newOpen: boolean) => {
    if (newOpen) {
      setShowLabel(true);
    }
    setOpen(newOpen);
  };

  const getDivisionFromSubsidiary = (subsidiaryIdParam: string) => {
    if (!subsidiaryIdParam) {
      return;
    }

    const divisionUrl = `/v1/division/get-all-divisionBySubsidiary?subsidiary=${subsidiaryIdParam}`;
    get(divisionUrl)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          const responseData = res.response.data;
          if (responseData) {
            setDivisionData(responseData);
          } else {
            setDivisionData([]);
          }
        } else {
          setDivisionData([]);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        setDivisionData([]);
      });
  };

  const subsidiaryId = (subsidiaryData?.find((item: any) => item?.name === subsidiary) as any)?.subsidiaryId || '';
  useEffect(() => {
    getDivisionFromSubsidiary(subsidiaryId || '');
  }, [subsidiaryId]);

  const getDivisionRecords = () => {
    const divisionUrl = `/v1/division/get-all-division`;
    get(divisionUrl)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          let responseData = res.response.data;
          if (responseData) {
            responseData = responseData.map((item: string) => {
              return { division: item };
            });
            setDivisionData(responseData);
          } else {
            setDivisionData([]);
          }
        } else {
          console.error("Unexpected response structure:", res);
          setDivisionData([]);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        setDivisionData([]);
      });
  };

  useEffect(() => {
    getSubsidiaryRecords();
    getDivisionRecords();
  }, []);

  return (
    <>
      <Row
        gutter={12}
        justify={"end"}
        style={isMobile ? { rowGap: "10px" } : undefined}
      >
        {viewDate && (
          <Col
            xl={4}
            lg={4}
            md={12}
            sm={18}
            xs={24}
          >
            <RangePicker
              getPopupContainer={(trigger) => trigger.parentElement!}
              separator={
                <SwapOutlined
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                />
              }
              onChange={handleDateRangeChange}
              style={{ width: "100%", color: "grey" }}
              placeholder={["From Date", "To Date"]}
              allowClear
              value={
                startDate && endDate 
                  ? [moment(startDate), moment(endDate)] 
                  : null
              }     
              />
          </Col>
        )}
        {viewDate && (
          <Col
            xl={4}
            lg={4}
            md={12}
            sm={24}
            xs={24}
          >
            <Popover
              placement="bottom"
              content={<a onClick={() => hide}>{content}</a>}
              title="Budget/PTE"
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <Button
                style={{
                  width: "100%",
                  color: !hideAmountLabel ? "rgb(177, 176, 176)" : "black",
                  textAlign: "left",
                  overflow: "hidden",
                }}
                title="Budget/PTE"
              >
                <span
                  style={{
                    display: "inline-block",
                    maxWidth: "calc(100% - 20px)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    verticalAlign: "middle",
                  }}
                >
                  {showLabel && "Budget/PTE: "}
                  {!open && hideAmountLabel && `${numberToString(sliderValue[0])} - ${numberToString(sliderValue[1])}`}
                </span>{" "}
                <DollarOutlined
                  rev={undefined}
                  onPointerEnterCapture={undefined}
                  style={{ fontSize: 14 }}
                  onPointerLeaveCapture={undefined}
                />
              </Button>
            </Popover>
          </Col>
        )}
        {!viewSubsidiary && (
          <Col
            xl={4}
            lg={4}
            md={12}
            sm={24}
            xs={24}
          >
            <Row style={{ display: "contents" }}>
              <Col title="Select Subsidiary/Division">
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  style={{ color: !subsidiary ? "rgb(177, 176, 176)" : "black" }}
                  showSearch
                  filterOption={(input, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(e: any) => {
                    setpage && setpage(0);
                    if (e) {
                      setSearchParams({ ...paramsObj, "subsidiary":e,"division":''})
                    } else {
                      setSearchParams({ ...paramsObj, "subsidiary":''})
                    }
                  }}
                  value={subsidiary || undefined}
                  allowClear={!!subsidiary}
                  onClear={() => {
                    getDivisionRecords()
                    setSearchParams({ ...paramsObj, "subsidiary":''})
                  }}
                  className="w-100"
                  placeholder={"Select Subsidiary/Division"}
                >
                  {subsidiaryData &&
                    subsidiaryData.map((value: any, index: number) => (
                      <Select.Option
                        value={`${value.name}`}
                        key={`${index}-${value.subsidiaryId}`}
                      >
                        {value.name}
                      </Select.Option>
                    ))}
                </Select>
              </Col>
            </Row>
          </Col>
        )}
        {viewDivisions && (
          <Col
            xl={4}
            lg={4}
            md={12}
            sm={24}
            xs={24}
          >
            <Row style={{ display: "contents" }}>
              <Col title="Select Cost Centre">
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  style={{ color: !division ? "rgb(177, 176, 176)" : "black" }}
                  showSearch
                  filterOption={(input, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(e) => {
                    if (e) {
                      setSearchParams({ ...paramsObj, "division": e})

                    } else {
                      setSearchParams({ ...paramsObj, "division":''})

                    }
                  }}
                  value={division || undefined}
                  allowClear={division ? true : false}
                  className="w-100"
                  placeholder="Select Cost Centre"
                >
                  {divisionData &&
                    divisionData.map((value: any, index: number) => (
                      <Select.Option
                        value={value.division}
                        key={`${index}-division`}
                      >
                        {value.division}
                      </Select.Option>
                    ))}
                </Select>
              </Col>
            </Row>
          </Col>
        )}

        {authority === "headOfSubsidiary" && (
          <>
            <Col
              xl={4}
              lg={4}
              md={12}
              sm={24}
              xs={24}
            >
              <Row style={{ display: "contents" }}>
                <Col title="Select Budget">
                  <Select
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    style={{ color: !selectedBudget ? "rgb(177, 176, 176)" : "black" }}
                    showSearch
                    filterOption={(input, option: any) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(e) => {
                      if (e) {
                        setSelectedBudget(e);
                        setBudget(e);
                      } else {
                        setSelectedBudget("");
                        setBudget("");
                      }
                    }}
                    value={selectedBudget ? selectedBudget : "Select Budget"}
                    allowClear={selectedBudget ? true : false}
                    className="w-100"
                    placeholder="Select Budget"
                  >
                    {spaFilterBudget &&
                      spaFilterBudget.map((value: any, index: number) => {
                        return (
                          <Select.Option
                            value={value}
                            key={`${index}`}
                          >
                            {value}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Col>
              </Row>
            </Col>
          </>
        )}

        {isDashboardPath && (
          <>
            <Col
              xl={4}
              lg={4}
              md={12}
              sm={24}
              xs={24}
            >
              <Row style={{ display: "contents" }}>
                <Col title="Select Budget">
                  <Select
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    style={{ color: !budget ? "rgb(177, 176, 176)" : "black" }}
                    showSearch
                    filterOption={(input, option: any) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(e) => {
                      if (e) {
                        setSearchParams({...paramsObj,"budget":e})
                        // setSelectedBudget(e);
                        // setBudget(e);
                      } else {
                        setSearchParams({...paramsObj,"budget":""})
                        // setSelectedBudget("");
                        // setBudget("");
                      }
                    }}
                    value={budget||undefined}
                    allowClear={budget ? true : false}
                    className="w-100"
                    placeholder="Select Budget"
                  >
                    {spaFilterBudget &&
                      spaFilterBudget.map((value: any, index: number) => {
                        return (
                          <Select.Option
                            value={value}
                            key={`${index}`}
                          >
                            {value}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Col>
              </Row>
            </Col>

            <Col
              xl={4}
              lg={4}
              md={12}
              sm={24}
              xs={24}
            >
              <Row style={{ display: "contents" }}>
                <Col title="Select SPA Types">
                  <Select
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    style={{ color: !paper ? "rgb(177, 176, 176)" : "black" }}
                    showSearch
                    filterOption={(input, option: any) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(e) => {
                      if (e) {
                        setSearchParams({...paramsObj,"paper":e})
                        // setPaper(e);
                      } else {
                        setSearchParams({...paramsObj,"paper":''})
                        // setPaper("");
                      }
                    }}
                    value={paper||undefined}
                    allowClear={paper ? true : false}
                    className="w-100"
                    placeholder="Select SPA Types"
                  >
                    {spaFilterPaper &&
                      spaFilterPaper.map((value: any, index: number) => {
                        return (
                          <Select.Option
                            value={value}
                            key={`${index}`}
                          >
                            {value}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};
